import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const GITHUB_REPO = 'model-park/cli';

// GitHub Release API types
interface GitHubAsset {
    name: string;
    size: number;
    download_count: number;
    content_type: string;
    browser_download_url: string;
}

interface GitHubRelease {
    tag_name: string;
    published_at: string;
    body: string;
    html_url: string;
    assets: GitHubAsset[];
}

// Internal types used by UI components
export interface ReleaseAsset {
    name: string;
    size: number;
    download_count?: number;
    content_type?: string;
    browser_download_url: string;
}

export interface ReleaseManifest {
    version: string;
    tag_name: string;
    published_at: string;
    release_notes?: string;
    html_url: string;
    assets: ReleaseAsset[];
}

function transformRelease(release: GitHubRelease): ReleaseManifest {
    return {
        version: release.tag_name,
        tag_name: release.tag_name,
        published_at: release.published_at,
        release_notes: release.body || undefined,
        html_url: release.html_url,
        assets: release.assets.map(a => ({
            name: a.name,
            size: a.size,
            download_count: a.download_count,
            content_type: a.content_type,
            browser_download_url: a.browser_download_url,
        })),
    };
}

// GitHub public API (no auth needed for public repos)
export const releasesApiSlice = createApi({
    reducerPath: 'releasesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `https://api.github.com/repos/${GITHUB_REPO}/`,
    }),
    endpoints: builder => ({
        getLatestRelease: builder.query<ReleaseManifest, void>({
            query: () => 'releases/latest',
            transformResponse: (response: GitHubRelease) => transformRelease(response),
        }),
    }),
});

export const { useGetLatestReleaseQuery } = releasesApiSlice;
